import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col no-padding" }
const _hoisted_3 = { class: "column compatheader" }
const _hoisted_4 = { class: "row center items-center" }
const _hoisted_5 = { class: "col-xs-3 txt-ellips left q-px-sm" }
const _hoisted_6 = { class: "col-2 col-md-2 col-sm-2 col-xs-3 txt-ellips" }
const _hoisted_7 = { class: "col-md-6 col-lg-6 col-sm-7 col-xs-4 row" }
const _hoisted_8 = { class: "col gt-xs txt-ellips row justify-evenly" }
const _hoisted_9 = { class: "text-bold" }
const _hoisted_10 = { class: "col-7 col-md-7 col-sm-7 col-xs-12" }
const _hoisted_11 = { class: "row no-print" }
const _hoisted_12 = {
  key: 0,
  class: "col q-ml-md q-mr-md text-dark ellipsis",
  style: {"background":"#86FF81"}
}
const _hoisted_13 = {
  key: 1,
  class: "col q-ml-md q-mr-md text-dark bg-warning print-bg ellipsis",
  style: {"background":"#FEBF74"}
}
const _hoisted_14 = {
  key: 2,
  class: "col q-ml-md q-mr-md text-dark ellipsis",
  style: {"background":"#86FF81"}
}
const _hoisted_15 = {
  key: 3,
  class: "col q-ml-md q-mr-md text-dark bg-warning print-bg ellipsis",
  style: {"background":"#FEBF74"}
}
const _hoisted_16 = { class: "row print-only" }
const _hoisted_17 = {
  key: 0,
  class: "col q-ml-md q-mr-md text-dark ellipsis",
  style: {"background":"#86FF81"}
}
const _hoisted_18 = {
  key: 1,
  class: "col q-ml-md q-mr-md text-dark bg-warning print-bg ellipsis",
  style: {"background":"#FEBF74"}
}
const _hoisted_19 = {
  key: 2,
  class: "col q-ml-md q-mr-md text-dark ellipsis",
  style: {"background":"#86FF81"}
}
const _hoisted_20 = {
  key: 3,
  class: "col q-ml-md q-mr-md text-dark bg-warning print-bg ellipsis",
  style: {"background":"#FEBF74"}
}
const _hoisted_21 = { class: "col-1 row gt-sm justify-end q-pr-l no-print" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-1",
  style: {"width":"1px"}
}, null, -1)
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "row q-px-md" }
const _hoisted_26 = {
  class: "col text-primary text-h6 q-px-xs q-pt-md q-pb-xs row",
  style: {"border-bottom":"3px solid #00b482"}
}
const _hoisted_27 = { class: "text-bold" }
const _hoisted_28 = { class: "row q-pb-lg" }
const _hoisted_29 = {
  class: "column q-pa-md col-xs-12 col-md-6",
  style: {"gap":"20px"}
}
const _hoisted_30 = { class: "col" }
const _hoisted_31 = {
  class: "column",
  style: {"gap":"6px"}
}
const _hoisted_32 = { class: "text-bold" }
const _hoisted_33 = { class: "text-grey-7" }
const _hoisted_34 = {
  class: "column q-pa-md col-xs-12 col-md-6",
  style: {"gap":"20px"}
}
const _hoisted_35 = { class: "col" }
const _hoisted_36 = {
  class: "column",
  style: {"gap":"6px"}
}
const _hoisted_37 = { class: "text-bold" }
const _hoisted_38 = { class: "text-grey-7" }
const _hoisted_39 = { class: "column q-mb-lg" }
const _hoisted_40 = { class: "column q-px-md col" }
const _hoisted_41 = { class: "col" }
const _hoisted_42 = { class: "column" }
const _hoisted_43 = {
  class: "text-bold q-mb-md col",
  style: {"border-bottom":"2px solid rgb(0,0,0, 0.6)"}
}
const _hoisted_44 = { class: "col row q-pt-sm text-center" }
const _hoisted_45 = { class: "q-mr-xl q-mb-lg column items-start justify-start col-xs-6 col-md-4 col-lg-3" }
const _hoisted_46 = { class: "row text-bold text-left" }
const _hoisted_47 = { class: "justify-center" }
const _hoisted_48 = { class: "col row justify-start" }
const _hoisted_49 = { class: "q-mr-xl q-mb-sm column items-start" }
const _hoisted_50 = { class: "row text-bold" }
const _hoisted_51 = { class: "col justify-center" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "row no-wrap text-grey-7" }
const _hoisted_54 = { class: "q-mx-sm text-black" }
const _hoisted_55 = { class: "row no-wrap text-grey-7" }
const _hoisted_56 = { class: "q-mx-sm text-black" }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "col row justify-start" }
const _hoisted_59 = { class: "column items-start justify-start" }
const _hoisted_60 = { class: "row text-bold" }
const _hoisted_61 = { class: "col justify-center" }
const _hoisted_62 = { class: "row no-wrap text-grey-7" }
const _hoisted_63 = { class: "q-mx-sm text-black" }
const _hoisted_64 = { class: "row no-wrap text-grey-7" }
const _hoisted_65 = { class: "q-mx-sm text-black" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "row print-only q-my-md" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { class: "row q-px-md q-pt-lg no-print" }
const _hoisted_69 = {
  class: "text-bold col text-primary text-h6 q-px-xs q-pt-md q-pb-xs",
  style: {"border-bottom":"3px solid #00b482"}
}
const _hoisted_70 = { class: "column q-pa-md no-print" }
const _hoisted_71 = { class: "text-bold text-primary text-subtitle1 q-mb-sm" }
const _hoisted_72 = { class: "col row" }
const _hoisted_73 = {
  key: 0,
  class: "row items-center q-mb-sm col"
}
const _hoisted_74 = { class: "text-bold text-left" }
const _hoisted_75 = { class: "q-pl-md" }
const _hoisted_76 = { class: "no-print" }
const _hoisted_77 = {
  key: 0,
  class: "col text-primary ellipsis-3-lines q-px-sm"
}
const _hoisted_78 = {
  key: 1,
  class: "col text-primary ellipsis-3-lines q-px-sm"
}
const _hoisted_79 = {
  key: 2,
  class: "col text-primary ellipsis-3-lines q-px-sm"
}
const _hoisted_80 = {
  key: 3,
  class: "col text-primary ellipsis-3-lines"
}
const _hoisted_81 = { class: "row" }
const _hoisted_82 = {
  key: 0,
  class: "column col-xs-12 col-md q-mb-md"
}
const _hoisted_83 = { class: "col q-pa-md" }
const _hoisted_84 = { class: "row justify-center text-secondary" }
const _hoisted_85 = {
  class: "row justify-between text-secondary",
  style: {"position":"relative","top":"12px"}
}
const _hoisted_86 = {
  key: 1,
  class: "column col-xs-12 col-md q-mb-md"
}
const _hoisted_87 = { class: "col q-pa-md" }
const _hoisted_88 = { class: "row justify-center text-secondary" }
const _hoisted_89 = {
  class: "row justify-between text-secondary",
  style: {"position":"relative","top":"12px"}
}
const _hoisted_90 = {
  key: 2,
  class: "column col-xs-12 col-md q-mb-md"
}
const _hoisted_91 = { class: "col q-pa-md" }
const _hoisted_92 = { class: "row justify-center text-secondary" }
const _hoisted_93 = {
  class: "row justify-between text-secondary",
  style: {"position":"relative","top":"12px"}
}
const _hoisted_94 = {
  key: 3,
  class: "row col-12 q-mb-md"
}
const _hoisted_95 = { class: "col-12 q-pa-md" }
const _hoisted_96 = { class: "row justify-center text-secondary" }
const _hoisted_97 = {
  class: "row justify-between text-secondary",
  style: {"position":"relative","top":"12px"}
}
const _hoisted_98 = {
  class: "row",
  style: {"gap":"20px"}
}
const _hoisted_99 = {
  class: "row col-xs-12 col-md",
  style: {"gap":"20px"}
}
const _hoisted_100 = { class: "row col justify-center items-center" }
const _hoisted_101 = {
  class: "text-bold q-mr-sm",
  style: {"max-width":"80%","word-break":"all"}
}
const _hoisted_102 = { class: "ellipsis q-px-sm" }
const _hoisted_103 = {
  key: 1,
  class: "col-4 q-py-sm row justify-center",
  style: {"background":"#eee"}
}
const _hoisted_104 = { class: "ellipsis q-px-sm" }
const _hoisted_105 = { class: "row col justify-center items-center" }
const _hoisted_106 = {
  class: "text-bold q-mr-sm",
  style: {"max-width":"80%","word-break":"all"}
}
const _hoisted_107 = { class: "ellipsis q-px-sm" }
const _hoisted_108 = {
  key: 1,
  class: "col-4 q-py-sm row justify-center",
  style: {"background":"#eee"}
}
const _hoisted_109 = { class: "ellipsis q-px-sm" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-1",
  style: {"width":"1px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_slider = _resolveComponent("q-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        style: {"width":"100%","border":"none","background":"white"},
        class: _normalizeClass({
                isSelected: _ctx.myMed.selected,
                notSelected: !_ctx.myMed.selected,
              })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.medInfosExpansion())),
            class: "col med-info print-bg q-pb-xs q-pt-xs q-pr-none q-pl-none",
            style: {"width":"100%","border":"none","border-bottom":"1px solid #00b482","cursor":"pointer"}
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", null, _toDisplayString(_ctx.myMed.calculation.medicin.name) + " " + _toDisplayString(_ctx.myMed.calculation.medicin.nameLong), 1),
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.myMed.calculation.medicin.name) + " " + _toDisplayString(_ctx.myMed.calculation?.medicin?.nameLong || ''), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.myMed.calculation.medicin.activeAgent) + " ", 1),
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.myMed.calculation.medicin.activeAgent), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Compatibility.From')) + " ", 1),
                    _createElementVNode("b", null, _toDisplayString(_ctx.minMixingRatio()), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Compatibility.To')) + " ", 1),
                    _createElementVNode("b", null, _toDisplayString(_ctx.maxMixingRatio()), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.myMed.calculation.volumeUnit || ''), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.myMed.calculation.result4min)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('Compatibility.Compatible')), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('Compatibility.IncompatibleShort')), 1)),
                    (_ctx.myMed.calculation.result60min)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('Compatibility.Compatible')), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('Compatibility.IncompatibleShort')), 1))
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.myMed.calculation.result4min)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, " + "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, " - ")),
                    (_ctx.myMed.calculation.result60min)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, " + "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, " - "))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_q_icon, {
                  size: "sm",
                  class: _normalizeClass(["bg-primary", {'q-ml-sm': _ctx.$q.screen.lt.sm}]),
                  color: "white",
                  name: _ctx.myMed.selected ?  'expand_less' : 'expand_more'
                }, null, 8, ["class", "name"])
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["col med-content", { isSelected: _ctx.myMed.selected === true }])
          }, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_q_separator, {
                inset: "",
                vertical: ""
              }),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("Compatibility.PhysicoChemicalCompatibility.Results.MixDetails")) + " ", 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.myMed?.calculation?.medicin?.name ? ` - ${_ctx.myMed.calculation.medicin.name}` : ''), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('Compatibility.PhysicoChemicalCompatibility.Results.Concentration') + _ctx.$t('Colon')), 1),
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.myMed.calculation.preparation ?? '-'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("Compatibility.PhysicoChemicalCompatibility.Results.Comments") + _ctx.$t('Colon')), 1),
                        _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.myMed.calculation.description ?? '-'), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, _toDisplayString((_ctx.perfusionWay !== 'container' ? _ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.TestedIntervals') : _ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.TestedMix')) + _ctx.$t('Colon')), 1),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.perfusionWay !== 'container' ? _ctx.$t('Compatibility.PhysicoChemicalCompatibility.SolutionConcentration') : _ctx.$t('Compatibility.PhysicoChemicalCompatibility.Volume')), 1),
                              _createVNode(_component_q_tooltip, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.perfusionWay !== 'container' ? _ctx.$t('Compatibility.PhysicoChemicalCompatibility.SolutionConcentration') : _ctx.$t('Compatibility.PhysicoChemicalCompatibility.Volume')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getConcentrations(), (concentration, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "row items-start",
                                "no-wrap": "",
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_48, _toDisplayString((concentration.concentration + ' ' + concentration.volumeUnit)), 1)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["col-xs-12 col-lg no-wrap", _ctx.$q.screen.lt.sm ? 'column' : 'row'])
                          }, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.perfusionWay === 'container' ? _ctx.$t("Compatibility.PhysicoChemicalCompatibility.MedSolutionConcentration") : _ctx.$t("Compatibility.CompatibilityRequest.CarrierSolution")), 1),
                                _createVNode(_component_q_tooltip, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.perfusionWay === 'container' ? _ctx.$t("Compatibility.PhysicoChemicalCompatibility.MedSolutionConcentration") : _ctx.$t("Compatibility.CompatibilityRequest.CarrierSolution")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              (_ctx.perfusionWay !== 'container')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getIntervals(), (interval, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "row items-start",
                                        key: index
                                      }, [
                                        _createElementVNode("div", _hoisted_53, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('Compatibility.From')), 1),
                                          _createElementVNode("div", _hoisted_54, _toDisplayString(interval[0][0]), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_55, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('Compatibility.To')), 1),
                                          _createElementVNode("div", _hoisted_56, _toDisplayString(interval[0][1]), 1),
                                          _createTextVNode(_toDisplayString(_ctx.$t('Compatibility.mlperminute')), 1)
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAgentConcentration(), (concentration, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "row items-start",
                                        "no-wrap": "",
                                        key: index
                                      }, [
                                        _createElementVNode("div", _hoisted_58, _toDisplayString(concentration.concentration) + " " + _toDisplayString(concentration.volumeUnit), 1)
                                      ]))
                                    }), 128))
                                  ]))
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.$t('Compatibility.PhysicoChemicalCompatibility.MedSolution')), 1),
                                _createVNode(_component_q_tooltip, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('Compatibility.PhysicoChemicalCompatibility.MedSolution')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getIntervals(), (interval, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "row items-start no-wrap",
                                  key: index
                                }, [
                                  _createElementVNode("div", _hoisted_62, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('Compatibility.From')), 1),
                                    _createElementVNode("div", _hoisted_63, _toDisplayString(interval[_ctx.perfusionWay === 'container' ? 0 : 1][0]), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_64, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('Compatibility.To')), 1),
                                    _createElementVNode("div", _hoisted_65, _toDisplayString(interval[_ctx.perfusionWay === 'container' ? 0 : 1][1]), 1),
                                    _createTextVNode(_toDisplayString(_ctx.perfusionWay !== 'container' ? _ctx.$t('Compatibility.mlperminute') : _ctx.$t('Compatibility.ml')), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ], 2)
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_66,
                ((_ctx.myMed.calculation.result4min || _ctx.myMed.calculation.result60min))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t("Compatibility.PhysicoChemicalCompatibility.Results.PossibleResults")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.transport.name), 1),
                        _createElementVNode("div", _hoisted_72, [
                          (_ctx.perfusionWay !== 'coinfusion')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.$t('Compatibility.PhysicoChemicalCompatibility.Volume')+_ctx.$t('Colon')), 1),
                                _createElementVNode("div", _hoisted_75, [
                                  _createVNode(_component_q_select, {
                                    "input-class": "justify-end",
                                    class: "justify-end",
                                    dense: "",
                                    filled: "",
                                    options: _ctx.containerVolumeList,
                                    modelValue: _ctx.volumeModel,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.volumeModel) = $event)),
                                    suffix: "ml"
                                  }, null, 8, ["options", "modelValue"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("div", {
                            class: "row",
                            style: _normalizeStyle(_ctx.$q.screen.lt.md ? 'display: none' : '')
                          }, [
                            (_ctx.perfusionWay === 'coinfusion')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(_ctx.$t("Compatibility.PhysicoChemicalCompatibility.LeitungSlider1")), 1))
                              : _createCommentVNode("", true),
                            (_ctx.perfusionWay === 'coinfusion')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(_ctx.$t("Compatibility.PhysicoChemicalCompatibility.LeitungSlider2") + " (" + _ctx.formatedVolumeUnit + ")"), 1))
                              : _createCommentVNode("", true),
                            (_ctx.perfusionWay === 'coinfusion')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(_ctx.$t("Compatibility.PhysicoChemicalCompatibility.LeitungSlider3")), 1))
                              : _createCommentVNode("", true),
                            (_ctx.perfusionWay === 'container')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(_ctx.$t("Compatibility.PhysicoChemicalCompatibility.BehaltnisSlider2")), 1))
                              : _createCommentVNode("", true)
                          ], 4),
                          _createElementVNode("div", _hoisted_81, [
                            (_ctx.perfusionWay === 'coinfusion')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                  _createElementVNode("div", {
                                    class: "col text-primary ellipsis-3-lines q-px-sm",
                                    style: _normalizeStyle(_ctx.$q.screen.lt.md ? '' : 'display: none')
                                  }, _toDisplayString(_ctx.$t("Compatibility.PhysicoChemicalCompatibility.LeitungSlider1")), 5),
                                  _createElementVNode("div", _hoisted_83, [
                                    _createElementVNode("div", _hoisted_84, [
                                      _createVNode(_component_q_input, {
                                        debounce: "2000",
                                        dense: "",
                                        "input-class": "text-right",
                                        borderless: "",
                                        style: {"border":"1px solid lightgrey"},
                                        suffix: "ml / min",
                                        class: "q-px-sm",
                                        modelValue: _ctx.coinfusionModelSolution,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.coinfusionModelSolution) = $event)),
                                        onChange: _cache[3] || (_cache[3] = (value) => {
                                                                    if (isNaN(parseFloat(value))) {
                                                                        _ctx.coinfusionModelSolution = 0;
                                                                    }
                                                                })
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_85, [
                                      _createElementVNode("div", null, _toDisplayString(_ctx.toFixedL(Number(_ctx.minimalSlider1 ?? 0), 2)), 1),
                                      _createElementVNode("div", null, _toDisplayString(_ctx.toFixedL(Number(_ctx.maximalSlider1 ?? 0), 2)), 1)
                                    ]),
                                    _createVNode(_component_q_slider, {
                                      modelValue: _ctx.coinfusionModelSolution,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.coinfusionModelSolution) = $event)),
                                      min: _ctx.minimalSlider1,
                                      max: _ctx.maximalSlider1,
                                      color: "primary",
                                      style: {"z-index":"1"},
                                      step: _ctx.stepSlider1
                                    }, null, 8, ["modelValue", "min", "max", "step"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.perfusionWay === 'coinfusion')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                  _createElementVNode("div", {
                                    class: "col text-primary text-subtitle1 ellipsis-3-lines q-px-sm",
                                    style: _normalizeStyle(_ctx.$q.screen.lt.md ? '' : 'display: none')
                                  }, _toDisplayString(_ctx.$t("Compatibility.PhysicoChemicalCompatibility.LeitungSlider2") + " (" + _ctx.formatedVolumeUnit + ")"), 5),
                                  _createElementVNode("div", _hoisted_87, [
                                    _createElementVNode("div", _hoisted_88, [
                                      _createVNode(_component_q_input, {
                                        debounce: "2000",
                                        dense: "",
                                        "input-class": "text-right",
                                        borderless: "",
                                        style: {"border":"1px solid lightgrey"},
                                        suffix: _ctx.formatedVolumeUnit,
                                        class: "q-px-sm",
                                        modelValue: _ctx.coinfusionModelAgentSolution,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.coinfusionModelAgentSolution) = $event)),
                                        onChange: _cache[6] || (_cache[6] = (value) => {
                                                                    if (isNaN(parseFloat(value))) {
                                                                        _ctx.coinfusionModelAgentSolution = 0;
                                                                    }
                                                                })
                                      }, null, 8, ["suffix", "modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_89, [
                                      _createElementVNode("div", null, _toDisplayString(_ctx.toFixedL(Number(_ctx.minimalSlider2 ?? 0), 2)), 1),
                                      _createElementVNode("div", null, _toDisplayString(_ctx.toFixedL(Number(_ctx.maximalSlider2 ?? 0), 2)), 1)
                                    ]),
                                    _createVNode(_component_q_slider, {
                                      modelValue: _ctx.coinfusionModelAgentSolution,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.coinfusionModelAgentSolution) = $event)),
                                      min: _ctx.minimalSlider2,
                                      max: _ctx.maximalSlider2,
                                      color: "primary",
                                      style: {"z-index":"1"},
                                      step: _ctx.stepSlider2
                                    }, null, 8, ["modelValue", "min", "max", "step"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.perfusionWay === 'coinfusion')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                  _createElementVNode("div", {
                                    class: "col text-primary text-subtitle1 ellipsis-3-lines q-px-sm",
                                    style: _normalizeStyle(_ctx.$q.screen.lt.md ? '' : 'display: none')
                                  }, _toDisplayString(_ctx.$t("Compatibility.PhysicoChemicalCompatibility.LeitungSlider3")), 5),
                                  _createElementVNode("div", _hoisted_91, [
                                    _createElementVNode("div", _hoisted_92, [
                                      _createVNode(_component_q_input, {
                                        debounce: "2000",
                                        "input-class": "text-right",
                                        dense: "",
                                        borderless: "",
                                        style: {"border":"1px solid lightgrey"},
                                        suffix: "ml / min",
                                        class: "q-px-sm",
                                        modelValue: _ctx.coinfusionModelAgent,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.coinfusionModelAgent) = $event)),
                                        onChange: _cache[9] || (_cache[9] = (value) => {
                                                                if (isNaN(parseFloat(value))) {
                                                                    _ctx.coinfusionModelAgent = 0;
                                                                }
                                                            })
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_93, [
                                      _createElementVNode("div", null, _toDisplayString(_ctx.toFixedL(Number(_ctx.minimalSlider3 ?? 0), 2)), 1),
                                      _createElementVNode("div", null, _toDisplayString(_ctx.toFixedL(Number(_ctx.maximalSlider3 ?? 0), 2)), 1)
                                    ]),
                                    _createVNode(_component_q_slider, {
                                      modelValue: _ctx.coinfusionModelAgent,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.coinfusionModelAgent) = $event)),
                                      min: _ctx.minimalSlider3,
                                      max: _ctx.maximalSlider3,
                                      color: "primary",
                                      style: {"z-index":"1"},
                                      step: _ctx.stepSlider3
                                    }, null, 8, ["modelValue", "min", "max", "step"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.perfusionWay === 'container')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                  _createElementVNode("div", {
                                    class: "col-12 text-primary text-subtitle1 ellipsis-3-lines q-px-sm q-pb-md",
                                    style: _normalizeStyle(_ctx.$q.screen.lt.md ? '' : 'display: none')
                                  }, _toDisplayString(_ctx.$t("Compatibility.PhysicoChemicalCompatibility.BehaltnisSlider2")), 5),
                                  _createElementVNode("div", _hoisted_95, [
                                    _createElementVNode("div", _hoisted_96, [
                                      _createVNode(_component_q_input, {
                                        debounce: "2000",
                                        dense: "",
                                        "input-class": "text-right",
                                        borderless: "",
                                        style: {"border":"1px solid lightgrey"},
                                        suffix: "ml",
                                        class: "q-px-sm",
                                        modelValue: _ctx.containerModel,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.containerModel) = $event)),
                                        onChange: _cache[12] || (_cache[12] = (value) => {
                                                                if (isNaN(parseFloat(value))) {
                                                                    _ctx.containerModel = 0;
                                                                }
                                                            })
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_97, [
                                      _createElementVNode("div", null, _toDisplayString(_ctx.toFixedL(Number(_ctx.minimalSlider4 ?? 0), 2)), 1),
                                      _createElementVNode("div", null, _toDisplayString(_ctx.toFixedL(Number(_ctx.maximalSlider4 ?? 0), 2)), 1)
                                    ]),
                                    _createVNode(_component_q_slider, {
                                      modelValue: _ctx.containerModel,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.containerModel) = $event)),
                                      min: _ctx.minimalSlider4,
                                      max: _ctx.maximalSlider4,
                                      color: "primary",
                                      style: {"z-index":"1"},
                                      step: _ctx.stepSlider4
                                    }, null, 8, ["modelValue", "min", "max", "step"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("div", _hoisted_100, [
                              _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.DirectDetails')+_ctx.$t('Colon')), 1),
                              (_ctx.isBetween)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "col-4 q-py-sm row justify-center",
                                    style: _normalizeStyle(_ctx.displayResult4 ? 'background: #86FF81' : 'background: #FEBF74')
                                  }, [
                                    _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.displayResult4 ? _ctx.$t('Compatibility.Compatible') : _ctx.$t('Compatibility.Incompatible')), 1)
                                  ], 4))
                                : (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                    _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.$t('Compatibility.NotTested')), 1)
                                  ]))
                            ]),
                            _createElementVNode("div", _hoisted_105, [
                              _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.perfusionWay === 'container' ? (_ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.Indirect24')+_ctx.$t('Colon')) : (_ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.Indirect60')+_ctx.$t('Colon'))), 1),
                              (_ctx.isBetween)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "col-4 q-py-sm row justify-center",
                                    style: _normalizeStyle(_ctx.displayResult60 ? 'background: #86FF81' : 'background: #FEBF74')
                                  }, [
                                    _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.displayResult60 ? _ctx.$t('Compatibility.Compatible') : _ctx.$t('Compatibility.Incompatible')), 1)
                                  ], 4))
                                : (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                    _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.$t('Compatibility.NotTested')), 1)
                                  ]))
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_q_separator, {
                inset: "",
                vertical: ""
              }),
              _hoisted_110
            ])
          ], 2)
        ])
      ], 2),
      (_ctx.myMed.selected)
        ? (_openBlock(), _createBlock(_component_q_separator, {
            key: 0,
            color: "primary"
          }))
        : _createCommentVNode("", true),
      (!_ctx.myMed.selected)
        ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ]))
}